import { render, staticRenderFns } from "./SmsPatternManager.vue?vue&type=template&id=f264b130&scoped=true"
import script from "./SmsPatternManager.vue?vue&type=script&lang=js"
export * from "./SmsPatternManager.vue?vue&type=script&lang=js"
import style0 from "./SmsPatternManager.vue?vue&type=style&index=0&id=f264b130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f264b130",
  null
  
)

export default component.exports